import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { ToastService } from '../core/services/toast.service';
import * as AppActions from './app.actions';

@Injectable({
  providedIn: 'root'
})
export class AppEffects {
  setMessage = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AppActions.SetSnackbar),
        map((action) => action.payload),
        tap((message) => this.toastService.setMessage(message))
      );
    },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private toastService: ToastService
  ) {}
}
